import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { getUser } from '../auth/LoginState'
import Happy from '../../assets/images/reactions/Happy.svg'
import Sad from '../../assets/images/reactions/Sad.svg'
import Proud from '../../assets/images/reactions/Proud.svg'
import Laughter from '../../assets/images/reactions/Laughter.svg'
import { userAction, logResourceAction } from '../../helpers/logs'

type ER = {
    resource: string
    happy: boolean
    happyCounter: number
    sad: boolean
    sadCounter: number
    proud: boolean
    proudCounter: number
    laughter: boolean
    laughterCounter: number
    getResources: () => void
    // logResourceAction: (action: string, reaction: string) => void
}

const EmojiReact: React.FC<ER> = ({
    resource,
    happy,
    happyCounter,
    sad,
    sadCounter,
    proud,
    proudCounter,
    laughter,
    laughterCounter,
    getResources,
    // logResourceAction,
}) => {
    const usr = getUser()
    const [showEmojis, setShowEmojis] = useState<boolean>(false)

    const update = async (t: string) => {
        let reactionState = ''

        if (t === 'happy') {
            if (happy) {
                reactionState = 'Happy OFF'
            } else {
                reactionState = 'Happy ON'
            }
        } else if (t === 'sad') {
            if (sad) {
                reactionState = 'Sad OFF'
            } else {
                reactionState = 'Sad ON'
            }
        } else if (t === 'proud') {
            if (proud) {
                reactionState = 'Proud OFF'
            } else {
                reactionState = 'Proud ON'
            }
        } else if (t === 'laughter') {
            if (laughter) {
                reactionState = 'Laughter OFF'
            } else {
                reactionState = 'Laughter ON'
            }
        }

        try {
            const res = await axios({
                method: 'put',
                url: `${process.env.REACT_APP_SERVER}/api/resource/${resource}/reaction`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Token ${usr.token}`,
                },
                data: {
                    type: t,
                    user: usr.id,
                    resourceId: resource,
                },
            })

            let finalReaction = ''

            if (t === 'happy') {
                if (happy) {
                    finalReaction = 'Happy OFF'
                } else {
                    finalReaction = 'Happy ON'
                }
            } else if (t === 'sad') {
                if (sad) {
                    finalReaction = 'Sad OFF'
                } else {
                    finalReaction = 'Sad ON'
                }
            } else if (t === 'proud') {
                if (proud) {
                    finalReaction = 'Proud OFF'
                } else {
                    finalReaction = 'Proud ON'
                }
            } else if (t === 'laughter') {
                if (laughter) {
                    finalReaction = 'Laughter OFF'
                } else {
                    finalReaction = 'Laughter ON'
                }
            }

            let reaction = {
                reaction: true,
                type: finalReaction,
                context: 'post',
            }

            // if (resource) {
            //     userAction(usr.id, 'Resource', resource, 'reaction', reaction)
            // }

            if (res.status === 201) {
                getResources()

                logResourceAction(usr, resource, 'Reaction', reactionState)

                setShowEmojis(false)
            } else {
                console.log('error with response')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleOutsideClick = (e: any) => {
        window.addEventListener('click', (e) => {
            // @ts-ignore
            if (e.target.id === 'modal-container') {
                setShowEmojis(false)
            }
        })
    }

    return (
        <>
            <div
                className='flex flex-col text-xs items-center mr-2 md:mr-4 text-blue1 font-cgbold cursor-pointer'
                onClick={(event) => {
                    setShowEmojis(!showEmojis)
                    handleOutsideClick(event)
                }}
            >
                <div className='mb-1'>Emoji reactions</div>
                <div className='justify-center items-center'>
                    <img
                        src={Happy}
                        alt='emoji reaction'
                        className={showEmojis ? 'w-10 rounded-full p-1 bg-blue2' : 'w-10 rounded-full p-1 bg-yellow1'}
                    />
                </div>
                <div className='mt-1'>{happyCounter + sadCounter + proudCounter + laughterCounter}</div>
            </div>

            {showEmojis ? (
                <div
                    className='fixed flex top-0 left-0 w-screen h-screen z-50 items-center justify-center'
                    id='modal-container'
                >
                    <div className='absolute w-48 rounded-lg shadow-xl p-4 ml-10 bg-white border-2 border-black/20 text-center'>
                        <span className='font-cgbold'>Select the emoji reaction you want</span>
                        <div>
                            <div
                                className={
                                    happy
                                        ? 'cursor-pointer flex item-center place-items-center w-full rounded-full bg-yellow1 my-1'
                                        : 'cursor-pointer flex item-center place-items-center w-full bg-transparent my-1'
                                }
                                onClick={() => update('happy')}
                            >
                                <img
                                    src={Happy}
                                    alt='happy emoji'
                                    className='w-10 rounded-full p-1 bg-blue2'
                                />
                                <span className='absolute w-6 h-6 text-2xs font-cgbold text-white rounded-full bg-blue1 ml-7 -mt-7 pt-1'>
                                    {happyCounter}
                                </span>
                                <span className='ml-3'>Happy</span>
                            </div>
                            <div
                                className={
                                    sad
                                        ? 'cursor-pointer flex item-center place-items-center w-full rounded-full bg-yellow1 my-1'
                                        : 'cursor-pointer flex item-center place-items-center w-full bg-transparent my-1'
                                }
                                onClick={() => update('sad')}
                            >
                                <img
                                    src={Sad}
                                    alt='sad emoji'
                                    className='w-10 rounded-full p-1 bg-blue2'
                                />
                                <span className='absolute w-6 h-6 text-2xs font-cgbold text-white rounded-full bg-blue1 ml-7 -mt-7 pt-1'>
                                    {sadCounter}
                                </span>
                                <span className='ml-3'>Sad</span>
                            </div>
                            <div
                                className={
                                    proud
                                        ? 'cursor-pointer flex item-center place-items-center w-full rounded-full bg-yellow1 my-1'
                                        : 'cursor-pointer flex item-center place-items-center w-full bg-transparent my-1'
                                }
                                onClick={() => update('proud')}
                            >
                                <img
                                    src={Proud}
                                    alt='proud emoji'
                                    className='w-10 rounded-full p-1 bg-blue2'
                                />
                                <span className='absolute w-6 h-6 text-2xs font-cgbold text-white rounded-full bg-blue1 ml-7 -mt-7 pt-1'>
                                    {proudCounter}
                                </span>
                                <span className='ml-3'>Proud</span>
                            </div>
                            <div
                                className={
                                    laughter
                                        ? 'cursor-pointer flex item-center place-items-center w-full rounded-full bg-yellow1 my-1'
                                        : 'cursor-pointer flex item-center place-items-center w-full bg-transparent my-1'
                                }
                                onClick={() => update('laughter')}
                            >
                                <img
                                    src={Laughter}
                                    alt='laughter emoji'
                                    className='w-10 rounded-full p-1 bg-blue2'
                                />
                                <span className='absolute w-6 h-6 text-2xs font-cgbold text-white rounded-full bg-blue1 ml-7 -mt-7 pt-1'>
                                    {laughterCounter}
                                </span>
                                <span className='ml-3'>Laughter</span>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default EmojiReact
